import { useCallback } from 'react'
import { HOME_PRODUCT_KEYS, SECONDARY_VIEW_KEYS } from '@/config/navigation/secondaryNav'
import PATHS from '@/routes/paths'

/** Open the standalone Connections page and clear the active chat thread. */
export function useSecondaryConnections({
  navigate,
  setSelectedThreadId,
  setHomeView,
  setHomeProduct,
}) {
  return useCallback(() => {
    setHomeProduct(HOME_PRODUCT_KEYS.CHAT)
    setHomeView(SECONDARY_VIEW_KEYS.HOME_MAIN)
    setSelectedThreadId(null)
    navigate(PATHS.CONNECTIONS)
  }, [navigate, setHomeProduct, setHomeView, setSelectedThreadId])
}
